/**
 * Admin Blog Categories API Service
 */

import { get, post, patch, del } from '../client';

export interface Category {
  id: string;
  name: string;
  slug: string;
  createdAt: string;
}

interface CategoriesResponse {
  success: boolean;
  message: string;
  data: Category[];
}

interface CategoryResponse {
  success: boolean;
  message: string;
  data: Category;
}

export async function getCategories(): Promise<Category[]> {
  const response = await get<CategoriesResponse>('/admin/categories');
  return response.data;
}

export async function createCategory(name: string): Promise<Category> {
  const response = await post<CategoryResponse>('/admin/categories', { name });
  return response.data;
}

export async function updateCategory(id: string, name: string): Promise<Category> {
  const response = await patch<CategoryResponse>(`/admin/categories/${id}`, { name });
  return response.data;
}

export async function deleteCategory(id: string): Promise<void> {
  await del(`/admin/categories/${id}`);
}
